import { tv, type VariantProps } from "../../../../util/tv";

export const institutionalProductCardVariants = tv({
  slots: {
    base: [
      "flex flex-col",
      "rounded-2xl",
      "aspect-[298/546]",
      "relative",
      "overflow-hidden",
      "border border-gray-500",
      "group",
    ],
    contentWrapper: [
      "z-10",
      "transition-[background]",
      "duration-300",
      "p-6",
      "w-full h-full",
      "flex flex-col flex-wrap",
      "justify-between",
    ],
    img: ["transition-all duration-300", "grayscale group-hover:grayscale-0"],
    header: [""],
    title: [],
    footer: ["flex gap-5", "flex-col", "pt-6", "mt-6", "transition-all"],
    description: ["border-b border-white/15", "pb-10"],
    logoWrapper: [
      "flex justify-center items-center",
      "h-[30px] w-auto",
      "mx-auto",
    ],
    logo: ["object-contain object-center", "max-h-[27px]"],
  },
  variants: {
    theme: {
      dark: {
        base: "text-white",
        description: ["text-white/80"],
      },
      light: {
        base: "text-black",
        description: ["text-black/80"],
      },
    },
  },
  defaultVariants: {
    theme: "dark",
  },
});

export type InstitutionalProductCardVariantProps = VariantProps<
  typeof institutionalProductCardVariants
>;

export type InstitutionalProductCardReturnVariantProps = ReturnType<
  typeof institutionalProductCardVariants
>;
